export const rpgAdventureManager = {
  name: "RPG Adventure Manager",
  excerpt: "Mobile Campaign Managment for RPG Games",
  image: "simpleLeadTracker.webp",
  localUrl: "rpg-adventure-manager",
  url: "#",
  description: "RPG Adventure Manager is a mobile app for dungeon masters running tabletop RPG games. It's the perfect tool for keeping track of your players, NPCs, quests, and more.",
  challenge: "Our end goal was create something that was generic enough to be used across multiple games. We wanted it to also be very simple so that users could quickly add what they needed, and then get back to the game.",
  solution: "The end result is a simple to use but powerful tool that lets users manage every part of their campaign. Since launch, we've added additional list building features, and even a drag and drop interface to build branching story paths.",
  tech: ["Reagent", "Clojurescript", "Cordova"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
